import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const QuestionCourseIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      {...props}
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.25 3.75C7.69329 3.75 4 7.44329 4 12C4 16.5558 7.69335 20.25 12.25 20.25C16.8067 20.25 20.5 16.5558 20.5 12C20.5 7.44329 16.8067 3.75 12.25 3.75ZM2.5 12C2.5 6.61487 6.86487 2.25 12.25 2.25C17.6351 2.25 22 6.61487 22 12C22 17.3841 17.6352 21.75 12.25 21.75C6.86481 21.75 2.5 17.3841 2.5 12Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1973 15.4463C12.6115 15.4463 12.9473 15.7821 12.9473 16.1963V16.2245C12.9473 16.6387 12.6115 16.9745 12.1973 16.9745C11.7831 16.9745 11.4473 16.6387 11.4473 16.2245V16.1963C11.4473 15.7821 11.7831 15.4463 12.1973 15.4463Z"
        fill={props.fill || "currentColor"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.30273 10.1933C9.30273 8.45393 10.702 7.05469 12.4414 7.05469C14.1706 7.05469 15.5791 8.45254 15.5791 10.1933C15.5791 11.4196 14.877 12.2867 13.9642 12.7914C13.9074 12.8238 13.8532 12.8543 13.8013 12.8835C13.5368 13.0323 13.334 13.1464 13.1681 13.2956C13.0052 13.4422 12.9439 13.5664 12.9461 13.7397C12.9516 14.1539 12.6202 14.4941 12.206 14.4995C11.7918 14.5049 11.4517 14.1736 11.4463 13.7594C11.4369 13.0415 11.7749 12.5313 12.1649 12.1805C12.4672 11.9084 12.8428 11.6994 13.1037 11.5542C13.148 11.5296 13.189 11.5068 13.2257 11.4858L13.2353 11.4804C13.7893 11.1751 14.0791 10.7531 14.0791 10.1933C14.0791 9.28375 13.345 8.55469 12.4414 8.55469C11.5304 8.55469 10.8027 9.28236 10.8027 10.1933C10.8027 10.6075 10.4669 10.9433 10.0527 10.9433C9.63852 10.9433 9.30273 10.6075 9.30273 10.1933Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default QuestionCourseIcon;
